import { useCallback, useEffect, useState } from 'react';
import { useNonRevalidatingFetcher } from './useNonRevalidatingFetcher';

interface Props {
  itunesId: string;
  count?: number;
  enabled?: boolean;
}

const useRssApplePodcast = ({ itunesId, count = 10, enabled }: Props) => {
  const fetcher = useNonRevalidatingFetcher<any>();
  const [hasFetched, setHasFetched] = useState(false);

  const fetchRssApplePodcast = useCallback(
    (itunesId: string, count: number) => {
      const url = `https://itunes.apple.com/lookup?id=${itunesId}&entity=podcastEpisode&limit=${count}`;
      fetcher.load(url);
    },
    [fetcher],
  );

  useEffect(() => {
    if (itunesId && !hasFetched && enabled) {
      fetchRssApplePodcast(itunesId, count);
      setHasFetched(true);
    }
  }, [itunesId, count, hasFetched, fetchRssApplePodcast]);

  return {
    data: fetcher.data,
    isLoading: fetcher.state === 'loading' || !fetcher.data,
    isError: itunesId && fetcher.state !== 'idle' && fetcher.state !== 'loading' && !fetcher.data,
    fetchRssApplePodcast,
  };
};

export default useRssApplePodcast;
